import { Loader2, Send } from "lucide-react";
import { useSimpleForm, FIELD } from "../hooks/useSimpleForm";

const INITIAL = { name: "", email: "", message: "" };

export const MaintenanceForm = () => {
  const { form, set, submit, loading } = useSimpleForm(INITIAL, "/api/maintenance/request", {
    success: "Demande envoyée ! Nous revenons vers vous très vite.",
    error: "L'envoi a échoué. Appelez-nous au 07 84 67 88 02.",
  });

  return (
    <form
      data-testid="maintenance-request-form"
      onSubmit={submit}
      className="mx-auto mt-6 max-w-3xl rounded-3xl border border-navy/10 bg-white p-6 sm:p-8"
    >
      <h3 className="text-center font-display text-lg font-bold text-navy">
        Déjà abonné ? Demandez votre modification
      </h3>
      <p className="mt-1 text-center text-sm text-slate-600">
        Décrivez le changement souhaité : nous nous en occupons.
      </p>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1.5 block text-xs font-semibold text-navy" htmlFor="maintenance-name">Nom *</label>
          <input id="maintenance-name" data-testid="maintenance-name-input" className={FIELD} placeholder="Marie Dupont" value={form.name} onChange={set("name")} required minLength={2} />
        </div>
        <div>
          <label className="mb-1.5 block text-xs font-semibold text-navy" htmlFor="maintenance-email">Email *</label>
          <input id="maintenance-email" data-testid="maintenance-email-input" type="email" className={FIELD} placeholder="marie@exemple.fr" value={form.email} onChange={set("email")} required />
        </div>
      </div>
      <div className="mt-4">
        <label className="mb-1.5 block text-xs font-semibold text-navy" htmlFor="maintenance-message">Modification souhaitée *</label>
        <textarea id="maintenance-message" data-testid="maintenance-message-input" className={`${FIELD} min-h-20 resize-y`} placeholder="Changer la photo de la page d'accueil et ajouter les horaires d'été…" value={form.message} onChange={set("message")} required minLength={5} />
      </div>
      <button
        type="submit"
        data-testid="maintenance-submit-button"
        disabled={loading}
        className="group mx-auto mt-5 flex items-center justify-center gap-2 rounded-full bg-navy px-7 py-3 text-sm font-semibold text-white transition-all hover:bg-navy-light hover:shadow-lg hover:shadow-gold/25 disabled:opacity-60"
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={14} className="transition-transform group-hover:translate-x-0.5" />}
        {loading ? "Envoi en cours…" : "Envoyer ma demande"}
      </button>
    </form>
  );
};
